import { CUSTOMIZE_PRODUCT } from "../constants/orderConstants";
import axios from "../lib/axios";
//
export const getValances = async (clutch, rud, shade, fabric_width) => {
	const res = await axios.post("editBlind/getValances", {
		clutch: clutch,
		rud: rud,
		shade: shade,
		fabric_width: fabric_width,
	});
	return res.data;
};

export const getDrivePrice = async () => {
	const res = await axios.get("editBlind/getDrivePrice");
	return res.data;
};

export const getDeflection = async (length) => {
	const res = await axios.post("editBlind/getDeflection", {
		length: length,
	});
	return res.data;
};

export const groupFabric = async (width, shade) => {
	const res = await axios.post("editBlind/getFabrics", {
		width: width,
		shade: shade,
	});
	return res.data;
};

export const filterFabricsByGroup = async (
	width,
	shade,
	group,
	series,
	color
) => {
	const res = await axios.post("editBlind/filterFabrics", {
		width: width,
		shade: shade,
		group: group,
		series: series,
		color: color,
	});
	return res.data;
};

export const calculateTotalPrice = async (
	length,
	width,
	shade,
	priceGroup,
	drive,
	valance,
	channel,
	remote,
	charger,
	connector
) => {
	const res = await axios.post("editBlind/calculatePrice", {
		length: length,
		width: width,
		shade: shade,
		priceGroup: priceGroup,
		drive: drive,
		valance: valance,
		channel: channel,
		remote: remote,
		charger: charger,
		connector: connector,
	});
	return res.data;
};

export const getBottomBars = async (shade, hem_name, defaultBottomBar) => {
	const res = await axios.post("editBlind/getBottomBars", {
		shade: shade,
		hem_name: hem_name,
		defaultBottomBar: defaultBottomBar,
	});
	return res.data;
};

export const customizeProduct = (data) => async (dispatch, getState) => {
	dispatch({ type: CUSTOMIZE_PRODUCT, payload: data });
	// localStorage.setItem(
	// 	"customizeProduct",
	// 	JSON.stringify(getState().customize.customizeProduct)
	// );
};

export const getDrive = async (
	shade,
	fabric,
	width,
	length,
	hem,
	δ,
	system
) => {
	const res = await axios.post("editBlind/getDrive", {
		shade: shade,
		fabric: fabric,
		width: width,
		length: length,
		hem: hem,
		deflection: δ,
		system: system,
	});
	return res.data;
};

export const getPriceDifference = async (shade, length, width) => {
	const res = await axios.post("editBlind/getPriceDifference", {
		shade: shade,
		length: length,
		width: width,
	});
	return res.data;
};

export const calculateDrop = (scale, maxDrop) => {
	return scale * maxDrop;
};

export const calculateDiameter = (
	tube_diam,
	totalDrop,
	currentDrop,
	thickness
) => {
	return Math.sqrt(
		(4 / Math.Pi()) *
			((Math.Pi() * tube_diam ** 2) / 4 + (totalDrop - currentDrop) * thickness)
	);
};

export const calculateTotalRevsToWind = (drop, maxDiam, tubeDiam) => {
	return drop / (Math.Pi() * ((maxDiam + tubeDiam) / 2));
};

export const calculateRotations = (revs, currentDrop, maxDrop) => {
	return (revs * currentDrop) / maxDrop;
};

export const calculateWeightFabDrop = (
	width,
	deduction,
	currentDrop,
	fabWeight
) => {
	return ((width - deduction) * currentDrop * fabWeight) / 1000000000;
};

export const calculateResultingOD = (tube_diam, wrap, thickness) => {
	let resulting_OD =
		2 * Math.sqrt(tube_diam ** 2 / 4 + (wrap * thickness) / Math.Pi());
	// resulting_OD = round(resulting_OD, 2, PHP_ROUND_HALF_DOWN);
	return resulting_OD;
};

export const calculateMaxRollDia = (tube_diam, drop, wrap, thickness) => {
	let maxOD =
		2 * Math.sqrt(tube_diam ** 2 / 4 + ((drop + wrap) * thickness) / Math.Pi());
	// maxOD = round(maxOD, 2, PHP_ROUND_HALF_DOWN);
	return maxOD;
};

export const calculateAffectOfSA = (k, diam, rotations) => {
	return (-k / (diam / 2 / 1000) / 9.81) * rotations;
};

export const calculateAffectOfPreRots = (preRots, k, diam) => {
	return (-preRots * k) / (diam / 2 / 1000) / 9.81;
};

export const calculatePulleyRatio = (avgRollDiam, pulleyDiam) => {
	return avgRollDiam / pulleyDiam;
};

export const calculateKgToLift = (
	_clutchDrag,
	_pulleyRatio,
	_totalWeight,
	_affectSA,
	_affectPreRot,
	_friction,
	_gearRatio
) => {
	return (
		_clutchDrag +
		(_pulleyRatio *
			(_totalWeight + _affectSA + _affectPreRot) *
			(1 + _friction)) /
			_gearRatio
	);
};

export const calculateKgToLower = (
	_clutchDrag,
	_pulleyRatio,
	_totalWeight,
	_affectSA,
	_affectPreRot,
	_friction,
	_gearRatio
) => {
	return (
		_clutchDrag +
		(_pulleyRatio *
			(-_totalWeight - _affectSA - _affectPreRot) *
			(1 + _friction)) /
			_gearRatio
	);
};

export const calculateKValue = (
	weightTop,
	weightBottom,
	avgDiam,
	rotTop,
	rotBottom
) => {
	return -(
		((weightBottom - weightTop) * (avgDiam / 2 / 1000) * 9.81) /
		(rotTop - rotBottom)
	);
};

export const calculatePreRots = (weight, affectS, avgRollDiam, k) => {
	return ((weight + affectS) * (avgRollDiam / 2 / 1000) * 9.81) / k;
};

// Create a class ScaleRow
export class ScaleRow {
	constructor(
		scale,
		width,
		length,
		thickness,
		diam,
		maxDiam,
		deduction,
		fWeight,
		hWeight,
		k,
		avgDiam,
		pRotations,
		pDiam,
		pRatio,
		fric,
		gRatio
	) {
		this.scale = scale;
		this.currentDrop = calculateDrop(scale, length);
		this.diameter = calculateDiameter(
			diam,
			length,
			this.currentDrop,
			thickness
		);
		let totalRevs = calculateTotalRevsToWind(length, maxDiam, diam);
		this.rotations = calculateRotations(totalRevs, this.currentDrop, length);
		this.weightFabDrop = calculateWeightFabDrop(
			width,
			deduction,
			this.currentDrop,
			fWeight
		);
		this.weightBB = hWeight;
		this.weightTotalDrop = this.weightFabDrop + this.weightBB;
		this.affectSA = calculateAffectOfSA(k, avgDiam, this.rotations);
		this.affectPreRots = calculateAffectOfPreRots(pRotations, k, avgDiam);
		this.pulleyRatio = calculatePulleyRatio(avgDiam, pDiam);
		this.KgToLift = calculateKgToLift(
			0.5,
			pRatio,
			this.weightTotalDrop,
			this.affectSA,
			this.affectPreRots,
			fric,
			gRatio
		);
		this.KgToLower = calculateKgToLower(
			0.5,
			pRatio,
			this.weightTotalDrop,
			this.affectSA,
			this.affectPreRots,
			fric,
			gRatio
		);
	}

	updateTableAfterK(k, avgDiam, pRotations, pDiam, pRatio, fric, gRatio) {
		this.affectSA = calculateAffectOfSA(k, avgDiam, this.rotations);
		this.affectPreRots = calculateAffectOfPreRots(pRotations, k, avgDiam);
		this.pulleyRatio = calculatePulleyRatio(avgDiam, pDiam);
		this.KgToLift = calculateKgToLift(
			0.5,
			pRatio,
			this.weightTotalDrop,
			this.affectSA,
			this.affectPreRots,
			fric,
			gRatio
		);
		this.KgToLower = calculateKgToLower(
			0.5,
			pRatio,
			this.weightTotalDrop,
			this.affectSA,
			this.affectPreRots,
			fric,
			gRatio
		);
	}
}
